import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import "./InfoBar.css";

const InfoBar = () => (
  <div className="infobar">
    <div className="infobar__box">

      <div className="infobar__content">
        <span className="infobar__label">We're here to help</span>
        <h2 className="infobar__title">
          Need Help? Talk to <em>Our Expert.</em>
        </h2>
        <p className="infobar__text">
          Have questions, need advice, or want to discuss your requirements?
          Our team is here every step of the way — just a call away.
        </p>
      </div>

      <div className="infobar__actions">
        <a href="tel:+919818961783" className="infobar__btn-phone">
          <Phone size={16} strokeWidth={2.5} />
          +91 9818961783
        </a>
        <Link to="/contactus" className="infobar__btn-contact">
          Contact Us
          <ArrowRight size={15} strokeWidth={2.5} />
        </Link>
      </div>

    </div>
  </div>
);

export default InfoBar;